import {
  PROGRAM_CREATE_FAIL,
  PROGRAM_CREATE_REQUEST,
  PROGRAM_CREATE_RESET,
  PROGRAM_CREATE_SUCCESS,
  PROGRAM_DELETE_FAIL,
  PROGRAM_DELETE_REQUEST,
  PROGRAM_DELETE_RESET,
  PROGRAM_DELETE_SUCCESS,
  PROGRAM_LIST_FAIL,
  PROGRAM_LIST_REQUEST,
  PROGRAM_LIST_RESET,
  PROGRAM_LIST_SUCCESS,
  PROGRAM_UPDATE_FAIL,
  PROGRAM_UPDATE_REQUEST,
  PROGRAM_UPDATE_RESET,
  PROGRAM_UPDATE_SUCCESS,
} from '../constants/programConstants'

export const programCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PROGRAM_CREATE_REQUEST:
      return { ...state, loading: true }
    case PROGRAM_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        program: action.payload,
      }
    case PROGRAM_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case PROGRAM_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const programListReducer = (state = {}, action) => {
  switch (action.type) {
    case PROGRAM_LIST_REQUEST:
      return { ...state, loading: true }
    case PROGRAM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        programs: action.payload,
      }
    case PROGRAM_LIST_FAIL:
      return { ...state, loading: false, error: action.payload }
    case PROGRAM_LIST_RESET:
      return {}
    default:
      return state
  }
}

export const programDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PROGRAM_DELETE_REQUEST:
      return { ...state, loading: true }
    case PROGRAM_DELETE_SUCCESS:
      return { ...state, loading: false, success: true }
    case PROGRAM_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case PROGRAM_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const programUpdateReducer = (state = { program: {} }, action) => {
  switch (action.type) {
    case PROGRAM_UPDATE_REQUEST:
      return { ...state, loading: true }
    case PROGRAM_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        program: action.payload,
      }
    case PROGRAM_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case PROGRAM_UPDATE_RESET:
      return {}
    default:
      return state
  }
}
